import VueRouter from 'vue-router';

const routes = [
  { path: '/', component: () => import('@/components/routes/Home.vue') },
  { path: '/sports', component: () => import('@/components/routes/Sports.vue') },
  { path: '/nature', component: () => import('@/components/routes/Nature.vue') },
  { path: '/automotive', component: () => import('@/components/routes/Automotive.vue') },
  { path: '/contact', component: () => import('@/components/routes/Contact.vue') },
];

const router = new VueRouter({
  routes,
});

export default router;
